import React from 'react';
import { Navigate, useLocation, useParams } from 'react-router-dom';
import { getServiceProviderProfilePath } from '../../utils/serviceProviderProfilePath';

const LegacyServiceProviderProfileRedirect: React.FC = () => {
  const { serviceId } = useParams<{ serviceId: string }>();
  const location = useLocation();

  if (!serviceId) {
    return <Navigate to="/" replace />;
  }

  const canonicalTarget = `${getServiceProviderProfilePath(serviceId)}${location.search}${location.hash}`;

  return <Navigate to={canonicalTarget} replace />;
};

export default LegacyServiceProviderProfileRedirect;
